import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import { CancelButton, ApplyButton, CheckBox } from '_components';
import styles from './Common.module.css';
import { Modal } from 'react-bootstrap';


class GoalTemplateDialog extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedTemplates: [],
        };
    }

    handleTemplateClick(GDNO) {
        let exists = this.state.selectedTemplates.includes(GDNO);

        if (!exists) {
            let tmpArray = this.state.selectedTemplates
            tmpArray.push(GDNO);
            this.setState({
                selectedTemplates: tmpArray,
            });
        }
        else {
            let tmpArray = this.state.selectedTemplates;
            let indexOf = tmpArray.indexOf(GDNO);
            tmpArray.splice(indexOf, 1)
            this.setState({
                selectedTemplates: tmpArray,
            });
        }
    }

    cancel() {
        this.state.selectedTemplates = [];
        this.props.toggleGoalTemplateDetails(this.props.noteId);

    }

    apply() {
        //add goals here
        this.props.applyGoalTemplateDetails(this.props.noteId, this.state.selectedTemplates)
        this.state.selectedTemplates = [];
        this.props.toggleGoalTemplateDetails(this.props.noteId);
    }

    render() {
        return (
            <Modal show={true} backdrop='static' keyboard={false} dialogClassName={styles.dialog}>
                <div className={styles.title} title={'Goal Template'}>
                    {'Goal Template'}
                </div>
                <div className={styles.content}>
                    {Object.keys(this.props.goalTemplateDetails)
                        .map(key => {
                            const tmp = this.props.goalTemplateDetails[key];
                            return (
                                <CheckBox
                                    key={tmp.GDNO}
                                    label={tmp.GDTITLE + ': ' + tmp.GDDESC}
                                    className={styles.checkbox_template}
                                    //checked={this.props.checked}
                                    onClick={() => this.handleTemplateClick(tmp.GDNO)}
                                />
                            )
                        })
                    }
                </div>
                <div className={styles.buttons}>
                    <span className={styles.button_wrapper}>
                        <ApplyButton size='small' title='Apply Template' onClick={() => this.apply()} />
                    </span>
                    <span className={styles.button_wrapper}>
                        <CancelButton size='small' title='Cancel' onClick={() => this.cancel()} />
                    </span>
                </div>
            </Modal>
        )
    }

}

function mapDispatchToProps(dispatch) {
    return {
        applyGoalTemplateDetails: bindActionCreators(noteActions.applyGoalTemplateDetails, dispatch),
        toggleGoalTemplateDetails: bindActionCreators(noteActions.toggleGoalTemplateDetails, dispatch),
    };
}

function mapStateToProps(state, ownprops) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);


    //selected
    let goalTemplateDetails = Object.keys(state.entities.notes.PTGOALTEMPLATEDETAILS)
        .filter(x => {
            return ((state.entities.notes.PTGOALTEMPLATEDETAILS[x].NoteId === noteId));
        })
        .sort((a, b) => state.entities.notes.PTGOALTEMPLATEDETAILS[a].GDORDER - state.entities.notes.PTGOALTEMPLATEDETAILS[b].GDORDER)
        .map(key => state.entities.notes.PTGOALTEMPLATEDETAILS[key]);

    let templateVisible = state.ui.notes[noteId].goalTemplateVisible;

    let allSelected = state.ui.notes[noteId].alTemplateAllSelected;


    return {
        noteId: noteId,
        goalTemplateDetails,

    };
}

const connectedGoalTemplateDialog = connect(mapStateToProps, mapDispatchToProps)(GoalTemplateDialog);
export { connectedGoalTemplateDialog as GoalTemplateDialog };
